import React from 'react'

const EmployeeDetailsAccrualsDeductions = () => {
  return (
    <div>EmployeeDetailsContract</div>
  )
}

export default EmployeeDetailsAccrualsDeductions